import { authHeader } from './auth-header'
import axiosInstance from "./client"

export const surplusService = {
  getAll,
  createOrUpdate,
  getById,
  deleteById,
}

function getById(surplusId) {
  const requestOptions = {
    url: '/api/v1/user/surplus/' + surplusId,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function getAll() {
  const requestOptions = {
    url: '/api/v1/user/surplus',
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}


function createOrUpdate(jsonData) {
  let formData = new FormData()
  jsonData['ID'] = jsonData['id']
  for (var key in jsonData) {
    if (jsonData[key] != null)
      formData.append(key, jsonData[key])
  }
  let rMethod = jsonData["id"] != null ? "PUT" : "POST"
  const requestOptions = {
    url: '/api/v1/user/surplus',
    method: rMethod,
    data: formData,
    headers: authHeader()
  }

  return axiosInstance(requestOptions)
}


function deleteById(id) {
  const requestOptions = {
    url: `/api/v1/user/surplus/` + id,
    method: 'DELETE',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

